<h1 mat-dialog-title>
  {{ 'ASSOCIATIONS.EDIT_ASSOCIATION_DIALOG.TITLE' | translate }}
</h1>
<mat-dialog-content>
  <h2 class="association-name">{{ data.associationName }}</h2>
  <crm-edit-association-tags
    [tags]="displayTags"
    [associationType]="associationType"
    (tagsChanged)="tagsChanged($event)"
  ></crm-edit-association-tags>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="cancel()">
    {{ 'ACTIONS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="save()">
    {{ 'ACTIONS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
